// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tire-campaigns .ssr-carousel-dot-icon{border:2px solid rgba(0,0,0,.7);border:none!important;border-radius:6px;display:inline-block;height:12px;height:10px!important;margin-left:4px;margin-right:4px;transition:opacity .2s;width:12px;width:40px!important}.tire-campaigns .ssr-carousel-dot-button .ssr-carousel-dot-icon{background-color:#1c1c1c}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
